import { axiosInstance } from "../axios-instance";

const itemsRoot = "products";
const itemsServices = {
  getItems: (categoryId) => axiosInstance.get(`${itemsRoot}/${categoryId}`),
  getItem: (productId) => axiosInstance.get(`${itemsRoot}/show/${productId}`),
  insertItem: (payload) =>
    axiosInstance.postForm(`${itemsRoot}/store`, payload),
  updateItem: (payload) =>
    axiosInstance.postForm(`${itemsRoot}/update/${payload.id}`, payload),
  deleteItem: (id) => axiosInstance.delete(`${itemsRoot}/delete/${id}`),

  sortItems: (arr) => axiosInstance.post(`${itemsRoot}/sortPrdouct`, arr),
  ////////////////////////////////////////////////////////////////////////
  getItemsBranch: (branchId) =>
    axiosInstance.get(`${itemsRoot}/branch/${branchId}`),
  unavailableItem: (productId) =>
    axiosInstance.post(`product/${productId}/unavailable`),
  hiddenItem: (productId) =>
    axiosInstance.post(`product/${productId}/hidden`),
};
export default itemsServices;
